import type { FirebaseError } from 'firebase/app';
import { GENERIC_LOGIN_FAILURE_MESSAGE } from './authDiagnostics';

export function getAuthErrorMessage(error: unknown): string {
  const code = (error as FirebaseError)?.code ?? '';

  switch (code) {
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
      return GENERIC_LOGIN_FAILURE_MESSAGE;
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Contact your administrator.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a few minutes and try again.';
    case 'auth/network-request-failed':
      return 'Network error. Check your connection and try again.';
    case 'auth/api-key-not-valid.-invalid-api-key':
      return (
        'Firebase API key is invalid. Update src/config/jkPresenceFirebaseConfig.ts with the ' +
        'Web app keys from Firebase Console → jk-presence → Project settings.'
      );
    default:
      return (error as Error)?.message || 'Failed to sign in';
  }
}

/**
 * Returns a user-visible error for password reset, or empty string when the error
 * should be swallowed (enumeration-safe success).
 */
export function getPasswordResetErrorMessage(error: unknown): string {
  const code = (error as FirebaseError)?.code ?? '';

  switch (code) {
    case 'auth/invalid-email':
      return 'Please enter a valid email address.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Please wait a few minutes and try again.';
    case 'auth/network-request-failed':
      return 'Network error. Check your connection and try again.';
    default:
      return '';
  }
}
